import './DocumentsAdministratifs.scss';

import React from 'react';
import { useEffect } from 'react';
import PropTypes from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';

function NavBarDonneeProfile({type, role}){
    NavBarDonneeProfile.propTypes = {
        type: PropTypes.any,
        role: PropTypes.any,
    };
    const {pathname} = useLocation();
    const currentPath = pathname.split('/').pop();

    const navigate = useNavigate();
    const { i18n } = useTranslation();
    useEffect(() => {
        console.log('path',pathname);
    });

    return(
        <div
            className='frame6CompteExpert'
            style={{flexDirection:'row',width:'100%',flexWrap:'wrap'}}
        >
            <div
                className='frame7CompteExpert'
                style={
                    currentPath == 'ProfilePersonnel' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                }
            >
                <p
                    //className='titleNavBarCompteExpert'
                    style={
                        currentPath == 'DonneePersonnel' ?
                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                    }
                    onClick={()=>{
                        if(currentPath == 'DonneePersonnel')
                            navigate('.',{state:{'type':type}});
                        else
                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/DonneePersonnel',{state:{'type':type}}, { replace: true });

                    }}
                >{i18n.t('Profil personnel')}</p>
            </div>
            <div
                className='frame8CompteExpert'
                style={
                    currentPath == 'DonneeCV' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                }
            >
                <p
                    style={
                        currentPath == 'DonneeCV' ?
                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                    }
                    onClick={()=>{
                        if(currentPath == 'DonneeCV')
                            navigate('.',{state:{'type':type}});
                        else
                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/DonneeCV',{state:{'type':type}}, { replace: true });

                    }}
                >{i18n.t('Données CV')}</p>
            </div>
            <div
                className='frame9CompteExpert'
                style={
                    currentPath == 'Preference' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                }
            >
                <p
                    style={
                        currentPath == 'Preference' ?
                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                    }
                    onClick={()=>{
                        if(currentPath == 'Preference')
                            navigate('.',{state:{'type':type}});
                        else
                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/Preference',{state:{'type':type}}, { replace: true });

                    }}
                >{i18n.t('Préférences')}</p>
            </div>
            {role!='esn' &&
                <div
                    className='frame10CompteExpert'
                    style={
                        currentPath == 'Societe' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                    }
                >
                    <p
                        style={
                            currentPath == 'Societe' ?
                                SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                        }
                        onClick={()=>{
                            if(currentPath == 'Societe')
                                navigate('.',{state:{'type':type}});
                            else
                                navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/Societe',{state:{'type':type}}, { replace: true });

                        }}
                    >{i18n.t('Société')}</p>
                </div>
            }
        </div>

    );
}

export default NavBarDonneeProfile;